// extracted by mini-css-extract-plugin
module.exports = {"container":"qw5xPpsQvZ1XKx4bP7f9","visible":"_37Zjip2MWbpAOL8xkIR-UT","cancelBtn":"_1z9GvCe6kpON6mwdxOkTBM","icon":"_3UyRqUiYHdzDowz51Cl4YC","saveBtn":"_3haUH9QDAg1gCbqSojbDO2"};